import { m2mCleaning_cleanerV2 } from "@/endpoints/m2m-cleaning.cleaner-v2"
import { uploadWithPresignedUrl } from "@/utils/presignedUpload"

export const requestUploadCleaningEvidence = async (
    token: string,
    cleaningId: string,
    blob: Blob
): Promise<{ data: { imageId: string }; err: boolean }> => {
    try {
        const issueUrl = m2mCleaning_cleanerV2.issueEvidenceUploadUrl({
            cleaningId
        })
        const completeUrl = m2mCleaning_cleanerV2.completeEvidenceUpload({
            cleaningId
        })
        const completed = await uploadWithPresignedUrl<{ imageId: string }>({
            token,
            issueUrl,
            completeUrl,
            blob
        })
        if (!completed?.imageId) {
            throw new Error("imageId missing in complete response")
        }
        return {
            data: { imageId: completed.imageId },
            err: false
        }
    } catch {
        return {
            data: { imageId: "" },
            err: true
        }
    }
}

export const requestDeleteCleaningEvidence = async (
    token: string,
    cleaningId: string,
    imageId: string
): Promise<{ err: boolean }> => {
    // eslint-disable-next-line no-restricted-globals -- エラー時に{ err: bool }を返すパターンのためfetchを直接使用
    const resp = await fetch(
        m2mCleaning_cleanerV2.deleteEvidencePicture({ cleaningId }),
        {
            headers: {
                Authorization: `Bearer ${token}`
            },
            method: "DELETE",
            body: JSON.stringify({
                imageId
            })
        }
    )

    return {
        err: !resp.ok
    }
}
